export interface language {
  label: string;
  value: string;
  locale: string;
}

export const DEFAULT_lANGUAGES: language[] = [
  { label: 'English', value: 'en', locale: 'en-US' },
  { label: 'Nederlands', value: 'nl', locale: 'nl' },
];

export function getLanguage(value: string): language | undefined {
  return DEFAULT_lANGUAGES.find(lang => lang.value === value);
}

export function getLanguageLabel(value: string): string {
  const language = getLanguage(value);
  return language ? language.label : '';
}
